module.exports = __webpack_public_path__ + "img/Weapon_91.b49e77d8.png";